'use strict';

var defineProperty = require('../../node_modules/@babel/runtime/helpers/defineProperty.js');
var React = require('react');
var iconStyles = require('../iconStyles.js');
var SvgIcon = require('../../node_modules/@material-ui/core/esm/SvgIcon/SvgIcon.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var style = {
  fill: "none",
  stroke: "#fff",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: "14.72px"
};

var CompanyCamIcon = function CompanyCamIcon(props) {
  return React__default["default"].createElement(SvgIcon["default"], _objectSpread({}, props, {
    viewBox: "0 0 485 485"
  }), React__default["default"].createElement("g", null, React__default["default"].createElement("g", null, React__default["default"].createElement("rect", {
    fill: "#0277bc",
    width: "485",
    height: "485",
    rx: "67.52"
  }), React__default["default"].createElement("path", {
    style: style,
    d: "M211.11,363.84H87.23a14.77,14.77,0,0,1-14.77-14.77V245.73h55.13"
  }), React__default["default"].createElement("path", {
    style: style,
    d: "M327.79,245.73h84.14V349.07a14.77,14.77,0,0,1-14.77,14.77H274.44"
  }), React__default["default"].createElement("path", {
    style: style,
    d: "M293.2,251.44a52.19,52.19,0,1,1-.88-30"
  }), React__default["default"].createElement("path", {
    style: style,
    d: "M194.55,334.5c-19.47-35.92-37.43-74.91-37.43-96.58a85.48,85.48,0,0,1,3.95-25.78"
  }), React__default["default"].createElement("path", {
    style: style,
    d: "M310.16,296.59c-19.35,42-48.81,89.55-61.37,109.28a7.11,7.11,0,0,1-12,0c-5.82-9.14-15.27-24.26-25.65-42"
  }), React__default["default"].createElement("path", {
    style: style,
    d: "M175.44,185a85.66,85.66,0,0,1,153,52.95c0,8-2.43,18.31-6.48,30"
  }), React__default["default"].createElement("path", {
    style: style,
    d: "M161.07,212.15h-88V150.22a14.76,14.76,0,0,1,14.76-14.76h14.35l7.38-22.59H154.2l7.39,22.59H183l18.64-44.74H284l18.64,44.74H324.2l7.16-22.59H376l7.38,22.59h14.38a14.76,14.76,0,0,1,14.77,14.76l-1,61.93H354"
  }))));
};

var CompanyCamIcon$1 = iconStyles()(CompanyCamIcon);

module.exports = CompanyCamIcon$1;
